import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import {MitarbeiterItem} from '../../mitarbeiter.model';
import {stringify} from 'querystring';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Security} from '../../../../security';
import {Observable} from 'rxjs';



@Component({
    selector: 'app-mitarbeiter-table',
    templateUrl: './mitarbeiter-table.component.html',
    styleUrls: ['./mitarbeiter-table.component.scss'],
})
export class MitarbeiterTableComponent implements OnInit {
  public displayedColumns: string[] = [
    'salutation',
    'firstName',
    'lastName',
    'email',
    'mobile',
    'birthday',
  ];

  // tslint:disable-next-line:variable-name
  constructor(
    public router: Router,
    public security: Security
  )
  {

  }
  public showFunctions: boolean;
  public dataSource = new MatTableDataSource<MitarbeiterItem>();

  @Output()
  public editMitarbeiter = new EventEmitter<MitarbeiterItem>();

  @Output()
  public deleteMitarbeiter = new EventEmitter<MitarbeiterItem>();

  @Output()
  public reactivateMitarbeiter = new EventEmitter<MitarbeiterItem>();

  @Input()
  public showFunctionMenu = true;

  /**
   * Sets addresses to datasource
   *
   * @param addresses - The addresses
   */
  @Input()
  public set mitarbeiter(mitarbeiter: MitarbeiterItem[]) {
    this.dataSource.data = mitarbeiter;
  }

    /**
     * Executed in initialization
     */
    public ngOnInit(): void {
      this.security.checkLogin('1001').subscribe(
        x => {
          console.log(x);
          this.showFunctions = x;

        });
      if (this.showFunctionMenu) {
        this.displayedColumns = this.displayedColumns.concat('actions');
      }
    }

  public zeiterfassung(userId: number): void {
      sessionStorage.setItem('zeitUserId', userId.toString());
      this.router.navigate(['zeitverwaltung']);
  }
}
